module.exports = __webpack_public_path__ + "static/media/gwp_10y_n-1.f196c502.csv";